import { useEffect, useState } from "react";
import { isElectronDesktop, type SyncStatus } from "../desktop";

export function SyncStatusChip() {
  const [status, setStatus] = useState<SyncStatus | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isElectronDesktop() || !window.brexDesktop?.getSyncStatus) return;
    let unsub: (() => void) | undefined;
    void window.brexDesktop.getSyncStatus().then(setStatus);
    unsub = window.brexDesktop.onSyncStatus?.(setStatus);
    return () => unsub?.();
  }, []);

  if (!status) return null;

  let label = "Offline";
  let cls = "sync-chip offline";
  if (status.syncing) {
    label = status.error?.startsWith("Reconnecting")
      ? "Reconnecting…"
      : "Syncing…";
    cls = "sync-chip syncing";
  } else if (status.online) {
    label = status.outboxPending > 0 ? `Online · ${status.outboxPending} pending` : "Online";
    cls = "sync-chip online";
  } else if (status.error) {
    if (/reconnect/i.test(status.error)) {
      label = "Reconnecting…";
      cls = "sync-chip syncing";
    } else {
      label = status.error.length > 36 ? "Offline" : status.error;
      cls = "sync-chip offline";
    }
  }

  const showReconnect = !status.online || Boolean(status.error);

  async function reconnect() {
    if (!window.brexDesktop?.reconnectSync || busy) return;
    setBusy(true);
    try {
      await window.brexDesktop.reconnectSync();
      const next = await window.brexDesktop.getSyncStatus?.();
      if (next) setStatus(next);
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className="sync-chip-wrap">
      <span className={cls} title={status.error || status.lastSyncAt || undefined}>
        {label}
      </span>
      {showReconnect && (
        <button
          type="button"
          className="btn ghost compact sync-reconnect-btn"
          disabled={busy || status.syncing}
          onClick={() => void reconnect()}
          title="Reconnect to hub and refresh live sync"
        >
          {busy ? "…" : "Reconnect"}
        </button>
      )}
    </span>
  );
}
